import { defineStore } from 'pinia'
import Vue from 'vue'
import i18n from '../plugins/i18n'
import { updateStoreState, deleteStoreState, sortObjects } from '../helpers/stateUtils'
import { useUnitStore, useAlertStore } from './'
import {
  BEAM_API,
} from '../constants'

export const useBookingStore = defineStore({
  id: 'booking',
  state: () => ({
    bookings: [],
  }),
  getters: {
    findById: (state) => (id) => state.bookings.find(find => find.id === id),
    findByIds: (state) => (ids) => sortObjects(state.bookings.filter(find => ids.includes(find.id)), 'dates.start'),
    findInternalByIds: (state) => (ids) => sortObjects(state.bookings.filter(find => find.channel.internal === true && ids.includes(find.id)), 'dates.start'),
    findExternalByIds: (state) => (ids) => sortObjects(state.bookings.filter(find => find.channel.internal !== true && ids.includes(find.id)), 'dates.start'),
  },
  actions: {
    httpCreateBooking ({ booking, unit }) {
      const unitStore = useUnitStore()
      const alertStore = useAlertStore()

      return Vue.prototype.$httpEZ.post(`/unit/${unit.id}/booking`, booking)
        .then((response) => {
          if (booking.noDatesToBlock !== true) {
            updateStoreState(this.bookings, response.data)

            // add the relation to the unit
            unit.bookings.push(response.data.id)
          }

          unit.ready = true
          updateStoreState(unitStore.units, unit)

          const i18nSuccessKey = booking.noDatesToBlock === true ? 'page-unit-manual-booking.actions.add-booking-no-dates.toast-success' : 'page-unit-manual-booking.actions.add-booking.toast-success'
          alertStore.setAlertSuccess({ message: i18n.t(i18nSuccessKey) })
        })
        .catch(() => {
          const i18nErrorKey = booking.noDatesToBlock === true ? 'page-unit-manual-booking.actions.add-booking-no-dates.toast-error' : 'page-unit-manual-booking.actions.add-booking.toast-error'
          alertStore.setAlertError({ message: i18n.t(i18nErrorKey) })
        })
    },

    httpDeleteBooking ({ booking, unit }) {
      const unitStore = useUnitStore()
      const alertStore = useAlertStore()

      return Vue.prototype.$httpEZ.delete(`${BEAM_API}/bookings/${booking.id}`)
        .then(() => {
          deleteStoreState(this.bookings, booking.id)

          // remove the relation from the unit
          unit.bookings = unit.bookings.filter(item => item !== booking.id)
          updateStoreState(unitStore.units, unit)

          alertStore.setAlertSuccess({ message: i18n.t('page-unit-manual-booking.actions.delete-booking.toast-success') })
        })
        .catch(() => {
          alertStore.setAlertError({ message: i18n.t('page-unit-manual-booking.actions.delete-booking.toast-error') })
        })
    },

    httpGetBookingsByUnit ({ unit }) {
      const unitStore = useUnitStore()
      const alertStore = useAlertStore()

      return Vue.prototype.$httpEZ.get(`${BEAM_API}/units/${unit.id}/bookings`)
        .then((response) => {
          const bookings = response.data['hydra:member']
          if (bookings.length > 0) {
            updateStoreState(this.bookings, bookings)
            unit.bookings = bookings.map(booking => booking.id)
          }

          updateStoreState(unitStore.units, unit)
        })
        .catch((error) => {
          alertStore.setAlertError({ message: i18n.t('page-unit-manual-booking.actions.load-bookings.toast-error') })
          throw error
        })
    },
  },
})
